import useDispatchify from 'common/hooks/utils/useDispatchify';
import { createJiraReauthModal } from 'modals/modal-options-factory';
import { toggleModal as toggleModalCaller } from 'state/callers';
import { isSensorOAuth2 } from 'common/services/sensors.service';
import { connectJiraOAuth2 } from 'common/services/jira-auth.service';
import { useMemo } from 'react';
import { PM_PROVIDERS } from 'common/constants/constants';
import useIsSensorSupportOAuth2 from './useIsSensorSupportOAuth2';

const useSensorReauthHandler = sensor => {
  const toggleModal = useDispatchify(toggleModalCaller);
  const isSupportOAuth2 = useIsSensorSupportOAuth2(sensor);

  const reauthAction = useMemo(() => {
    const isOAuth2 = isSensorOAuth2(sensor);
    const mapProivderToAction = {
      [PM_PROVIDERS.JIRA]: () =>
        isOAuth2 || isSupportOAuth2
          ? connectJiraOAuth2({ sensor_auth_id: sensor?.id })
          : toggleModal(createJiraReauthModal())
    };

    return mapProivderToAction[sensor?.sensor_id];
  }, [sensor]);

  return {
    onReauth: reauthAction
  };
};

export default useSensorReauthHandler;
